import { GuestActionDto } from "../../../../../networking/data/responses/GuestActionDto";
import { GuestActionType } from "../../../../../networking/data/responses/GuestActionType";
import { SceneIndex } from "../../../../SceneIndex";
import { Action } from "../../Action";
import { AddToHomeScreenDialogData } from "./AddToHomeScreenDialogData";
import { CashoutDialogData } from "./CashoutDialogData";
import { CookiesDialogData } from "./CookiesDialogData";
import { DialogData } from "./DialogData";
import { LeaderboardIntroductionData } from "./LeaderboardIntroductionData";
import { MenuDialogData } from "./MenuDialogData";
import { MyBuildingsDialogData } from "./MyBuildingsDialogData";
import { PushDialogData } from "./PushDialogData";
import { RenterQuestIntroductionData } from "./RenterQuestIntroductionData";
import { ShopDialogData } from "./ShopDialogData";
import { SocialCommunities } from "./SocialCommunities";
import { TournamentIntroductionData } from "./TournamentIntroductionData";
import { TutorialDialogData } from "./TutorialDialogData";
import { UpgradeDialogData } from "./UpgradeDialogData";

export class DialogAction implements Action {
    public readonly dialogData: DialogData;
    public readonly sceneIndex: SceneIndex;

    public constructor(dto: GuestActionDto) {
        if (dto == null) {
            throw new Error("You can't create DialogAction without providing GuestActionDto.");
        }
        if (dto.type != GuestActionType.DIALOG) {
            throw new Error(`You can't create DialogAction from GuestActionDto with type equal to ${dto.type}.`);
        }
        if (dto.dialogType == undefined || dto.dialogType == "") {
            throw new Error(`You can't create DialogAction from GuestActionDto with dialogType equal to ${dto.dialogType}.`);
        }
        this.sceneIndex = SceneIndex[dto.dialogType as keyof typeof SceneIndex];
        if (this.sceneIndex == undefined) {
            throw new Error(`Failed to convert ${dto.dialogType} into PopupIndex value. This popup probably not implemented yet.`);
        }
        this.dialogData = this.convertDialogTypeToSceneIndex(dto);
    }

    private convertDialogTypeToSceneIndex(dto: GuestActionDto): DialogData {
        const dialogType = dto.dialogType;
        switch (dialogType) {
            case SceneIndex.ALLOW_NOTIFICATIONS:
                return new PushDialogData(dto.allowPushNotificationsRewardInCoins);
            case SceneIndex.ADD_TO_HOME_SCREEN:
                return new AddToHomeScreenDialogData();
            case SceneIndex.CASHOUT:
                return new CashoutDialogData();
            case SceneIndex.COOKIES:
                return new CookiesDialogData();
            case SceneIndex.MENU:
                return new MenuDialogData();
            case SceneIndex.MY_BUILDINGS:
                return new MyBuildingsDialogData();
            case SceneIndex.TUTORIAL:
                return new TutorialDialogData();
            case SceneIndex.UPGRADE:
                return new UpgradeDialogData();
            case SceneIndex.STORE_INTRODUCTION:
                return new ShopDialogData();
            case SceneIndex.SOCIAL_COMMUNITIES:
                return new SocialCommunities();
            case SceneIndex.TOURNAMENT_INTRODUCTION:
                return new TournamentIntroductionData();
            case SceneIndex.RENTER_POLICY_INTRODUCTION:
                return new RenterQuestIntroductionData();
            case SceneIndex.LEADERBOARD_INTRODUCTION:
                return new LeaderboardIntroductionData();
            default:
                throw new Error(`Failed to convert dialogType: ${dialogType}. No data defined for it.`);
        }
    }
} 
